import useIsMobile from '@/lib/hooks/useIsMobile';
import useAnimatedPath from '@/lib/hooks/useAnimatedPath';
import { useWindowLoaded } from '@/lib/providers/WindowLoaded';

import styles from './CircleAnimationContent.module.scss';

export function CircleAnimationContent() {
  const enabled = useWindowLoaded();
  const isMobile = useIsMobile();

  const props = useAnimatedPath({ enabled, completed: isMobile });

  return (
    <svg width="288" height="85" viewBox="0 0 288 85" fill="none" xmlns="http://www.w3.org/2000/svg" className={styles.svg}>
      <path
        {...props}
        // eslint-disable-next-line max-len
        d="M98.4088 2C35.294 4.83994 -14.0061 31.2275 6.8567 56.3867C28.0514 81.9461 135.156 85.223 178.612 81.9461C222.068 78.6693 294.495 70.8048 285.183 35.4149C277.733 7.10289 164.126 10.0739 108.254 15.0984"
        stroke="var(--green)"
        strokeWidth="3"
      />
    </svg>
  );
}
